import React, { useEffect, useState } from "react";
import ComponentMenu from "../../components/layout/ComponentMenu";
import { Container, Spinner, Table } from "react-bootstrap";
import { MdAddCircleOutline, MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import ComponentTitle from "../../components/layout/ComponentTitle";
import { useTranslation } from "react-i18next";
import ComponentModaleNotifier from "../../components/layout/ComponentModaleNotifier";
import { apiGetNotifications } from "../../api/ApiNotification";
import { useSelector } from "react-redux";
import ModalDelete from "../../components/admin/notifier/ModalDelete";
import ModalUpdate from "../../components/admin/notifier/ModalUpdate";
import { toDateParseFR } from "../../utils/datesHeures";

const PageAdminNotifications = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [idNotification, setIdNotification] = useState("");
  const [showModalNotif, setShowModalNotif] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const recupNotifications = async () => {
    setLoading(true);
    const res = await apiGetNotifications(ReduxInstance._id, "sort=-datePeremption");
    if (res) {
      setNotifications(res.data);
      setLoading(false);
    } else {
      console.log("Error");
    }
  };

  const handleShowDelete = (id) => {
    setIdNotification(id);
    setShowDelete(true);
  };

  const handleCloseDelete = () => {
    setIdNotification(null);
    setShowDelete(false);
  };

  const handleShowUpdate = (id) => {
    setIdNotification(id);
    setShowUpdate(true);
  };

  const handleCloseUpdate = () => {
    setIdNotification(null);
    setShowUpdate(false);
  };

  useEffect(() => {
    recupNotifications();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ComponentModaleNotifier
        showModalNotif={showModalNotif}
        setShowModalNotif={setShowModalNotif}
        handleRecupDatas={recupNotifications}
      />
      <ComponentMenu />
      <Container>
        <ComponentTitle title={t("admin.PageAdminNotifications.titre")} />
        <span role="button" onClick={() => setShowModalNotif(true)}>
          <MdAddCircleOutline size="1.5em" />{" "}
          {t("admin.PageAdminNotifications.envoyerNotification")}
        </span>
        {loading ? (
          <div style={{ textAlign: "center", flex: 1 }}>
            <Spinner animation="grow" />
          </div>
        ) : (
          <Table striped bordered hover className="stickyTable mt-2">
            <thead>
              <tr>
                <th>{t("admin.PageAdminNotifications.titreColonne1")}</th>
                <th className="text-center">{t("admin.PageAdminNotifications.titreColonne2")}</th>
                <th className="text-center">{t("admin.PageAdminNotifications.titreColonne3")}</th>
                <th className="text-center">{t("admin.PageAdminNotifications.titreColonne4")}</th>
              </tr>
            </thead>
            <tbody>
              {notifications.map((notification) => (
                <tr key={notification._id}>
                  <td>{notification.title}</td>
                  <td className="text-center">
                    {notification.datePeremption ? toDateParseFR(notification.datePeremption) : "-"}
                  </td>
                  <td className="text-center">
                    <MdOutlineEdit
                      size="1.5em"
                      role="button"
                      onClick={() => handleShowUpdate(notification._id)}
                    />
                  </td>
                  <td className="text-center">
                    <MdDeleteOutline
                      size="1.5em"
                      role="button"
                      onClick={() => handleShowDelete(notification._id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        <ModalUpdate
          show={showUpdate}
          id={idNotification}
          handleClose={handleCloseUpdate}
          handleRecupDatas={recupNotifications}
        />
        <ModalDelete
          show={showDelete}
          id={idNotification}
          handleClose={handleCloseDelete}
          handleRecupDatas={recupNotifications}
        />
      </Container>
    </>
  );
};

export default PageAdminNotifications;
